import { HomeOutlined } from '@ant-design/icons'
import { Breadcrumb } from 'antd'

import { PTOProvider } from 'context/pto-context-provider'

import Content from './content'
import Overview from './overview'

import './style.scss'

const PTODetail = () => {
  return (
    <PTOProvider>
      <div className="main-section p2p-detail">
        <Breadcrumb
          items={[
            {
              href: '/',
              title: <HomeOutlined />,
            },
            {
              title: <span>PTO Detail</span>,
            },
          ]}
          style={{ marginBottom: '20px' }}
        />
        <Overview />
        <Content />
      </div>
    </PTOProvider>
  )
}

export default PTODetail
